import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import recorte from '../../assets/editorial/1_fotoKpa_recorte.png';
import fundo from '../../assets/editorial/1_fotoKpa_fundo.png';
import { useFontsReady } from '../../editorial/useFontsReady';

const COVER_ADVANCE_MS = 6600;

const Cover = ({ onNextPage }) => {
  const fontsReady = useFontsReady();
  const nextRef = useRef(onNextPage);
  nextRef.current = onNextPage;

  useEffect(() => {
    if (!fontsReady) return undefined;
    const timer = setTimeout(() => nextRef.current(), COVER_ADVANCE_MS);
    return () => clearTimeout(timer);
  }, [fontsReady]);

  return (
    <div className="experience cover">
      <div className="cover-stage">
        <div className="cover-frame">
          <div className="cover-window">
            <img className="cover-fundo" src={fundo} alt="" />
          </div>
          <img
            className="cover-photo"
            src={recorte}
            alt="Anne Frank de costas, escrevendo à mesa"
          />
        </div>
        <div className={clsx('cover-lockup', fontsReady && 'is-on')}>
          <img className="cover-mark" src="/anne_frontPage.png" alt="Anne" />
          <span className="cover-for">FOR</span>
        </div>
      </div>
    </div>
  );
};

export default Cover;
